import PropTypes from 'prop-types';
import React from 'react';
import css from './DisclaimerModal.scss';

export const DisclaimerModal = props => (
  <div className={css.DisclaimerModal}>
    <span className={css.DisclaimerModal__close} onClick={props.onClose}>
      x
    </span>
    {props.text}
  </div>
);

DisclaimerModal.propTypes = {
  text: PropTypes.element.isRequired,
  onClose: PropTypes.func,
};
